/**
 * The React context holding the `RootStore`, and nothing else.
 *
 * Split out of `StoreContext.tsx` (which re-exports it, so every existing
 * import is unchanged) because that module *builds* a `RootStore` — importing
 * it pulls the whole store graph, the editor and every repository into the
 * consumer's module graph. A consumer that only wants to *read* the context
 * should not pay for that; the store is a type here, so this module costs
 * nothing at runtime.
 */
import { createContext } from 'react';

import type { RootStore } from './RootStore';

export const StoreContext = createContext<RootStore | null>(null);
